/* eslint-disable no-unused-vars */
import { axiosPublic, axiosPrivate, getSequencer, getLocale } from ".";

export const getEvents = (producer, filtros, periodo_valido = false) =>
  axiosPrivate.post(
    "loja/produto/listar",
    {
      loja: producer,
      lang: getLocale(),
      filtros,
      periodo_valido_vendas: periodo_valido,
    },
    { cache: true }
  );

export const getEventsOfAnyStore = (
  producers,
  filtros,
  periodo_valido = true
) =>
  axiosPrivate.post(
    "loja/produto/listar",
    {
      lojas: producers,
      lang: getLocale(),
      filtros,
      listagem_mktp: true,
      periodo_valido_vendas: periodo_valido,
    },
    { cache: true }
  );

export const getEventByID = idproduto =>
  axiosPrivate.post(
    `loja/produto/${idproduto}`,
    {
      loja: getSequencer(),
    },
    { cache: true }
  );

export const getTypeEvent = () =>
  axiosPrivate.get("loja/produto/getTipos/pt/array", { cache: true });

export const deleteEvent = (producer, id) =>
  axiosPrivate.delete(`loja/${producer}/"produto/deletar/${id}`, {
    cache: true,
  });

export const getValidEvents = slug =>
  axiosPrivate.post(
    `loja/${slug}/produto/listar`,
    { tipo: "INGRESSO" },

    { cache: true }
  );

export const getLinkedEvents = producer =>
  axiosPrivate.get(`/evento/vinculado/${producer}`, {
    cache: true,
  });

export const uploadEventImage = ({
  file: img_base64,
  store: loja,
  product: idproduto,
  image: tipo_imagem,
  slug: slug,
}) =>
  axiosPrivate.post(
    "loja/produto/imagem/upload",
    {
      img_base64,
      idproduto,
      loja,
      tipo_imagem,
      slug,
    },
    {
      cache: false,
    }
  );

export const getVariations = opcoes =>
  axiosPrivate.post("loja/produto/variacoes/getvariacoes", opcoes, {
    cache: true,
  });

export const getAccessTypes = idproduto =>
  axiosPrivate.post(
    `getAccessTypes`,
    {
      loja: getSequencer(),
      idproduto: idproduto,
    },
    { cache: true }
  );

export const registerBins = (
  idproduto_variacao,
  iddesconto_bin,
  desconto_valor,
  desconto_perc,
  bins,
  banco,
  descricao,
  status,
  dthr_inicio,
  dthr_fim,
  idproduto
) =>
  axiosPrivate.post(
    "loja/produto/desconto/bin",
    {
      loja: getSequencer(),
      idproduto_variacao: idproduto_variacao,
      iddesconto_bin: iddesconto_bin,
      desconto_valor: desconto_valor,
      desconto_perc: desconto_perc,
      bins: bins,
      banco: banco,
      descricao: descricao,
      status: status,
      dthr_inicio: dthr_inicio,
      dthr_fim: dthr_fim,
      idproduto: idproduto,
    },
    { cache: true }
  );

export const getBins = idproduto =>
  axiosPrivate.post(
    `loja/produto/desconto/bin/${idproduto}`,
    {
      loja: getSequencer(),
    },
    { cache: true }
  );
